import { render } from "./bottombar.vue?vue&type=template&id=bcd0cada&scoped=true"
import script from "./bottombar.vue?vue&type=script&lang=js"
export * from "./bottombar.vue?vue&type=script&lang=js"

import "./bottombar.vue?vue&type=style&index=0&id=bcd0cada&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd0cada"]])

export default __exports__